import React from 'react';

import { Badge } from '@column/ui';

import { formatTransferType, getTransferBadgeClassName, getTransferIcon } from '../utils';
import { TransferEntryType } from '~/repositories';

interface TransferTypeBadgeProps {
  type: TransferEntryType;
}

export const TransferTypeBadge: React.FC<TransferTypeBadgeProps> = ({ type }) => (
  <Badge variant="ghost" className={getTransferBadgeClassName()}>
    {getTransferIcon(type)}
    {formatTransferType(type)}
  </Badge>
);
